import React, { useEffect, useState } from 'react'
import CheckBox from '@components/CheckBox'
import Collapse from '@whitecobalt/tungsten/esm/components/Collapse'
import Icon from '@whitecobalt/tungsten/esm/components/Icon'
import Slider, {SliderTooltip} from 'rc-slider'
import { FinishTypesDropdownQuery, FireRatingsDropdownQuery } from '@services/query/DropdownQueries'
import { useEffectMounted } from '@whitecobalt/tungsten/esm/common/hooks/useEffectMounted'
import  useWindowDimensions  from '@utils/getWindowDimensions'
import 'rc-slider/assets/index.css';
import './index.scss'
import SelectDropdown from '@whitecobalt/tungsten/esm/components/Fields/SelectDropdown'
import { useHistory } from 'react-router-dom'

const handleWithPounds = (props: any) => {
    const { value, dragging, index, ...restProps } = props;
    return (
      <SliderTooltip
        prefixCls="rc-slider-tooltip"
        overlay={`£${value}`}
        visible={dragging}
        placement="top"
        key={index}
      >
        <Slider.Handle value={value} {...restProps} />
      </SliderTooltip>
    );
}

const handleNumber = (props: any) => {
    const { value, dragging, index, ...restProps } = props;
    return (
      <SliderTooltip
        prefixCls="rc-slider-tooltip"
        overlay={`${value}`}
        visible={dragging}
        placement="top"
        key={index}
      >
        <Slider.Handle value={value} {...restProps} />
      </SliderTooltip>
    );
}

export type StateProps = {
    fireRating: number[],
    price: any[],
    length: any[],
    concealed: boolean | null,
    powered: boolean | null,
    includePoA: boolean | null,
    finish: number[],
    colour: string | null,
    halspanVerified: boolean | null,
    excludeNoFinishType: boolean,
}

interface ProductFilterProps {
    productTypeName: string;
    productCategory?: string;
    hasConcealed?: boolean;
    hasPrice?: boolean;
    hasFireRating?: boolean;
    hasFinish?: boolean;
    hasPowered?: boolean;
    hasColour?: boolean;
    hasLength?: boolean;
    hasHalspanVerified?: boolean;
    menuDescription?: string;
    maxPrice?: number;
    isFireRatingNoSmoke?: boolean;
    type?: string;
    onChange: (states: StateProps) => void;
    shopLinks: {
        label: string;
        value: string;
    }[]
    productTypeURL?: string;
    productCategoryURL?: string;
}

const ProductFilter: React.FunctionComponent<ProductFilterProps> = ({
    productTypeName,
    productCategory,
    hasConcealed,
    hasColour,
    hasFinish,
    hasPowered,
    hasLength,
    hasFireRating,
    hasPrice,
    hasHalspanVerified,
    menuDescription,
    maxPrice = 10000,
    isFireRatingNoSmoke = false,
    type,
    onChange,
    shopLinks,
    productTypeURL,
    productCategoryURL
}) => {
    const [states, setStates] = useState<StateProps>({
        fireRating: [],
        price: [1, maxPrice],
        length: [1, 10000],
        concealed: null,
        finish: [],
        includePoA: null,
        powered: null,
        colour: null,
        halspanVerified: null,
        excludeNoFinishType: false,
    })
	const { height, width } = useWindowDimensions();
    const history = useHistory()
    useEffectMounted(() => {
        const cleanup = setTimeout(() => onChange(states), 300)
        return () => clearTimeout(cleanup)
    }, [states])


    return (
        <>
            {/* {
                width <= 759 && shopLinks?.length > 0 &&(
                    <div className='mb-4'>
                        {
                            <SelectDropdown
                                required
                                name="shoplinks"
                                value={shopLinks.filter((link)=> link?.value === window.location.pathname)[0]?.value}
                                options={shopLinks}
                                showCaret={false}
                                clearable={false}
                                isAutoComplete={false}
                                onKeyPress={()=>undefined}
                                onChange={(e)=>{
                                    history.push(e.target.value)
                                }}
                                readOnly={true}
                                className={"mb-2"}
                                appendToggle={<Icon name="angle-right" />}
                            />
                        }
                    </div>
                    )
            } */}
            <div className="product-filter">
                {!!productCategory && (
                    <>
                    <nav aria-label="breadcrumb" className={`wc-breadcrumbs mt-0 ${width > 759 ? 'mb-3 wc-breadcrumbs-web-view' : 'mb-3'}`}>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href={productTypeURL || "#"}>{productTypeName}</a>
                            </li>
                            <li className="breadcrumb-item">
                                <a href={productCategoryURL || "#"}>{productCategory}</a>
                            </li>
                        </ol>
                    </nav>
                    </>
                )}
                <h2 className="product-filter-title mb-3">{productCategory || productTypeName}</h2>
                <p className="mb-5">
                    {
                        menuDescription ?  menuDescription :  ""
                    }
                </p>
                {(hasConcealed ||
                    hasColour ||
                    hasFinish ||
                    hasPowered ||
                    hasLength ||
                    hasFireRating ||
                    hasHalspanVerified ||
                    hasPrice) && (
                    <h2 className="product-filter-title">Filters</h2>
                )}
                {hasFireRating && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="fire-rating">
                            Fire Rating <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="fire-rating" transition="fast">
                            <div className="product-collapse-content">
                                <CheckBox.Graph 
                                    gql={FireRatingsDropdownQuery} 
                                    // variables={
                                    //     isFireRatingNoSmoke ? {
                                    //         where: {
                                    //         ID : {
                                    //             nin: [2, 3, 4, 5]
                                    //         } 
                                    //         }
                                    //     } : undefined
                                    // }
                                    name="fire-rating" 
                                    inline={false}
                                    value={states.fireRating}
                                    onChange={(event: any) => {
                                        const value = parseInt(event.target.value)
                                        const checked = event.target.checked
                                        setStates(prev => ({...prev, fireRating: checked ? [...prev.fireRating, value] : prev.fireRating.filter((each) => each !== value) }))
                                    }}
                                />
                            </div>
                        </Collapse> 
                    </div>
                )}
                {hasPrice && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="price">
                            Price (£) <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="price" transition="fast">
                            <div className="product-collapse-content">
                                <Slider.Range allowCross={false} min={1} max={maxPrice} value={states.price} handle={handleWithPounds} onChange={(value) => setStates(prev => ({...prev, price: value }))}/>
                                <div className="price-range mb-3">
                                    <input 
                                        type="number"
                                        value={states.price[0]} 
                                        min={1}
                                        max={maxPrice}
                                        onChange={(event) => {
                                            const value = event.target.value ? parseInt(event.target.value) : ''
                                            setStates(prev => ({...prev, price: [value, prev.price[1]] }))
                                        }}/> - 
                                    <input 
                                        type="number"
                                        value={states.price[1]}
                                        min={1}
                                        max={maxPrice}
                                        onChange={(event) => {
                                            const value = event.target.value ? parseInt(event.target.value) : ''
                                            setStates(prev => ({...prev, price: [prev.price[0], value] }))
                                        }}/>
                                </div>
                                <CheckBox
                                    name="includePoA" 
                                    type="checkbox"
                                    value={states.includePoA === true ? ['Yes'] : undefined}
                                    onChange={(event: any) => {
                                        const includePoA = event.target.checked
                                        setStates(prev => ({...prev, includePoA }))
                                    }}
                                    options={[
                                        {
                                            label: 'Include POA',
                                            value: 'Yes'
                                        }
                                    ]}
                                    />
                            </div>
                        </Collapse> 
                    </div>
                )}
                {hasLength && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="length">
                            Length (mm) <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="length" transition="fast">
                            <div className="product-collapse-content">
                                <Slider.Range allowCross={false} min={1} max={10000} value={states.length} handle={handleNumber as any} onChange={(value) => setStates(prev => ({...prev, length: value }))}/>
                                <div className="price-range">
                                <input 
                                        type="number"
                                        value={states.length[0]} 
                                        min={1}
                                        max={10000}
                                        onChange={(event) => {
                                            const value = event.target.value ? parseInt(event.target.value) : ''
                                            setStates(prev => ({...prev, length: [value, prev.length[1]] }))
                                        }}/> - 
                                    <input 
                                        type="number"
                                        value={states.length[1]}
                                        min={1}
                                        max={10000}
                                        onChange={(event) => {
                                            const value = event.target.value ? parseInt(event.target.value) : ''
                                            setStates(prev => ({...prev, length: [prev.length[0], value] }))
                                        }}/>
                                </div>
                            </div>
                        </Collapse> 
                    </div>
                )}
                {hasColour && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="colour">
                            Colour <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="colour" transition="fast">
                            <div className="product-collapse-content">
                                <input
                                    name="colour" 
                                    type="text"
                                    className="product-filter-freetext"
                                    placeholder="e.g. Black"
                                    value={states.colour || undefined}
                                    onChange={(event: any) => {
                                        const value = event.target.value
                                        setStates(prev => ({...prev, colour: value }))
                                    }}
                                    />
                                </div>
                        </Collapse> 
                    </div>
                )}
                {hasPowered && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="powered">
                            Powered <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="powered" transition="fast">
                            <div className="product-collapse-content">
                                <CheckBox
                                    name="powered" 
                                    type="radio"
                                    value={states.powered === true ? 'Yes' : states.powered === false ? 'No' : 'All'}
                                    onChange={(event: any) => {
                                        const value = event.target.value
                                        setStates(prev => ({...prev, powered: value === 'All' ? null : value === 'Yes' }))
                                    }}
                                    options={[
                                        {
                                            label: 'Yes',
                                            value: 'Yes'
                                        },
                                        {
                                            label: 'No',
                                            value: 'No'
                                        },
                                        {
                                            label: 'All',
                                            value: 'All'
                                        }
                                    ]}
                                    />
                                </div>
                        </Collapse>
                    </div>
                )}
                {hasConcealed && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="concealed">
                            Concealed <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="concealed" transition="fast">
                            <div className="product-collapse-content">
                                <CheckBox
                                    name="concealed" 
                                    type="radio"
                                    value={states.concealed === true ? 'Yes' : states.concealed === false ? 'No' : 'All'}
                                    onChange={(event: any) => {
                                        const value = event.target.value
                                        setStates(prev => ({...prev, concealed: value === 'All' ? null : value === 'Yes' }))
                                    }}
                                    options={[
                                        {
                                            label: 'Yes',
                                            value: 'Yes'
                                        },
                                        {
                                            label: 'No',
                                            value: 'No'
                                        },
                                        {
                                            label: 'All',
                                            value: 'All'
                                        }
                                    ]}
                                    />
                                </div>
                        </Collapse>
                    </div>
                )}
                {hasHalspanVerified && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="halspanVerified">
                            Halspan Verified <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="halspanVerified" transition="fast">
                            <div className="product-collapse-content">
                                <CheckBox
                                    name="halspanVerified" 
                                    type="radio"
                                    value={states.halspanVerified === true ? 'Yes' : states.halspanVerified === false ? 'No' : 'All'}
                                    onChange={(event: any) => {
                                        const value = event.target.value
                                        setStates(prev => ({...prev, halspanVerified: value === 'All' ? null : value === 'Yes' }))
                                    }}
                                    options={[
                                        {
                                            label: 'Yes',
                                            value: 'Yes'
                                        },
                                        {
                                            label: 'No',
                                            value: 'No'
                                        },
                                        {
                                            label: 'All',
                                            value: 'All'
                                        }
                                    ]}
                                    />
                                </div>
                        </Collapse>
                    </div>
                )}
                {hasFinish && (
                    <div className="product-filter-collapse">
                        <Collapse.Target as="div" className="product-collapse-target" eventKey="finish">
                            Finish <Icon name="angle-right"/>
                        </Collapse.Target>
                        <Collapse as="div" className="product-collapse" eventKey="finish" transition="fast">
                            <div className="product-collapse-content">
                                <CheckBox.Graph 
                                    gql={FinishTypesDropdownQuery} 
                                    variables={{
                                        where: {
                                            ID: {
                                                in: type === 'closers' ? [10, 11] : type === 'locks' ? [3, 4, 8, 10] : type === 'hinges' ? [10] : undefined,
                                                nin: type === 'others' ? [8, 11, 13, 15] : undefined
                                            }
                                        }
                                    }}
                                    name="finish"
                                    className='finish-list'
                                    inline={false}
                                    value={states.finish}
                                    onChange={(event: any) => {
                                        const value = parseInt(event.target.value)
                                        const checked = event.target.checked
                                        setStates(prev => ({...prev, finish: checked ? [...prev.finish, value] : prev.finish.filter((each) => each !== value) }))
                                    }}
                                />
                                <CheckBox
                                    name="excludeNoFinishType" 
                                    type="checkbox"
                                    value={states.excludeNoFinishType === true ? ['Yes'] : undefined}
                                    onChange={(event: any) => {
                                        const excludeNoFinishType = event.target.checked
                                        setStates(prev => ({...prev, excludeNoFinishType }))
                                    }}
                                    options={[
                                        {
                                            label: 'None',
                                            value: 'Yes'
                                        }
                                    ]}
                                />
                            </div>
                        </Collapse> 
                    </div>
                )}
            </div>
        </>
    )
}

export default ProductFilter
